export default [
    {
        path: '/term-options',
        name: 'term-options',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Opções de Resposta dos Termos',
            icon: 'mdi-format-list-checks',
            breadcrumbs: [
                { text: 'Lista de opções de resposta', disabled: true }
            ]
        }
    }
]
